<app-global-loader />
<app-toast />
<router-outlet />
